/**
 * @generated SignedSource<<bef5c0b744d93bea5a30d540015c2919>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type seriesWidgetContent$data = {
  readonly entityId: string;
  readonly seriesContainer: {
    readonly headline: string | null;
    readonly series: ReadonlyArray<{
      readonly entityId?: string;
      readonly " $fragmentSpreads": FragmentRefs<"seriesWidgetItemContent">;
    } | null> | null;
    readonly " $fragmentSpreads": FragmentRefs<"entityLink">;
  } | null;
  readonly " $fragmentSpreads": FragmentRefs<"seriesWidgetEntrypointHeadlineContent">;
  readonly " $fragmentType": "seriesWidgetContent";
};
export type seriesWidgetContent$key = {
  readonly " $data"?: seriesWidgetContent$data;
  readonly " $fragmentSpreads": FragmentRefs<"seriesWidgetContent">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "entityId",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "seriesWidgetContent",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "seriesWidgetEntrypointHeadlineContent"
    },
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "Article",
      "kind": "LinkedField",
      "name": "seriesContainer",
      "plural": false,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "entityLink"
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "headline",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": null,
          "kind": "LinkedField",
          "name": "series",
          "plural": true,
          "selections": [
            {
              "kind": "InlineFragment",
              "selections": [
                {
                  "args": null,
                  "kind": "FragmentSpread",
                  "name": "seriesWidgetItemContent"
                },
                (v0/*: any*/)
              ],
              "type": "Article",
              "abstractKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Article",
  "abstractKey": null
};
})();

(node as any).hash = "2d60cf78067bd355b6ae37e38207b543";

export default node;
